import IntegrationsPage from "@/app/integrations/pages/IntegrationsPage.vue";
import IntegrationsListTemplate from "@/app/integrations/components/templates/IntegrationsListTemplate.vue";

export default [
  {
    path: "/integrations",
    component: IntegrationsPage,
    children: [
      {
        path: "",
        component: IntegrationsListTemplate,
      },
    ],
    meta: { requiresAuth: true },
  },
];
